import {
  invoiceCandidatesCustomerCollectionGuard,
  invoiceCollectionGuard,
} from './_api/invoices';

export const invoicesRouteGuard = invoiceCollectionGuard;
export const invoiceCandidatesRouteGuard =
  invoiceCandidatesCustomerCollectionGuard;
